module.exports = __webpack_public_path__ + "img/back-home.c06909a0.png";